module.exports = __webpack_public_path__ + "img/approvalRecord.ccf60aaa.svg";